import { separateApiAuth } from './separate-api-auth';
import { injectEndpoints } from './extension';

export const api = injectEndpoints(separateApiAuth);
